import React, { useCallback } from 'react'
import cx from 'classnames'
import device from 'sw-modules/device'
import { analytics } from 'helpers'

import { Select, Tabs } from 'sw-components'
import { VaultsList } from 'components'

import SortAndSearch from './SortAndSearch/SortAndSearch'

import { useVaults, filterOptions, emptyMessages, vaultsLimit, sortOptions } from './util'


type VaultsProps = {
  className?: string
}

const VaultsTabs: React.FC<VaultsProps> = (props) => {
  const { className } = props

  const {
    total,
    vaults,
    filter,
    sortForm,
    isFetching,
    filterTabs,
    fetchNextItems,
  } = useVaults()

  const { isMobile } = device.useData()

  const handleSearchFocus = useCallback(() => {
    analytics.statistics.sendEvent('clickSearchFilter')
  }, [])

  const sortAndSearchNodes = (
    <SortAndSearch
      sortForm={sortForm}
      withSearch={filter === 'all'}
      sortOptions={sortOptions}
      onSearchFocus={handleSearchFocus}
    />
  )

  const listNode = (
    <VaultsList
      vaults={vaults}
      total={total || 0}
      isFetching={isFetching}
      fetchingSkeletonsCount={5}
      withDeposit={filter === 'deposits'}
      initialSkeletonsCount={vaultsLimit}
      emptyData={emptyMessages[filter || 'all']}
      onScroll={fetchNextItems}
    />
  )

  if (isMobile) {
    return (
      <div className={cx(className, 'mt-32 relative')}>
        <div className="flex justify-between items-center">
          <Select
            field={sortForm.fields.filter as Forms.Field<string>}
            options={filterOptions}
            placement="bottom-start"
          />
          {sortAndSearchNodes}
        </div>
        <div className="mt-16">
          {listNode}
        </div>
      </div>
    )
  }

  return (
    <Tabs
      className={cx(className, 'relative')}
      field={sortForm.fields.filter as Forms.Field<string>}
      noteNode={sortAndSearchNodes}
      tabsList={filterTabs}
    >
      <div className="mt-24">
        {listNode}
      </div>
    </Tabs>
  )
}


export default React.memo(VaultsTabs)
